import { JsonObject, JsonProperty } from 'typescript-json-serializer';

@JsonObject()
export class ChargingStatistics {
  @JsonProperty('TotalConsumption') totalConsumption: number;
  @JsonProperty('TotalHubjectConsumption') totalHubjectConsumption: number;
  @JsonProperty('AverageConsumption') averageConsumption: number;
  @JsonProperty('TotalTimeSpentSeconds') totalTimeSpentSeconds: number;
  @JsonProperty('AverageTimeSpentSeconds') averageTimeSpentSeconds: number;
  @JsonProperty('TotalEarnings') totalEarnings: number;
  @JsonProperty('TotalHubjectEarnings') totalHubjectEarnings: number;
  @JsonProperty('AverageEarnings') averageEarnings: number;
  @JsonProperty('AverageHubjectEarnings') averageHubjectEarnings: number;
  @JsonProperty('TotalChargings') totalChargings: number;
  @JsonProperty('TotalHubjectChargings') totalHubjectChargings: number;
}
